import { defineStore } from "pinia";

/**
 * Состояние мобильной навигации (CAB-489).
 *
 * Панель навигации на телефоне открывают три разных места — кнопка меню в
 * верхней панели, вкладка «Ещё» в нижней и свайп от левого края, — а закрывает
 * её ещё и сам переход по ссылке. Держать флаг внутри `SideBar` нельзя: тогда
 * верхней и нижней панелям пришлось бы дотягиваться до его внутренностей.
 */
export const useMobileNavStore = defineStore("mobileNav", {
  state: () => ({
    isDrawerOpen: false,
  }),

  actions: {
    openDrawer() {
      this.isDrawerOpen = true;
    },
    closeDrawer() {
      this.isDrawerOpen = false;
    },
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
  },
});
